<template>
  <div class="params-detail v3-sensorChart">
    <div :ref="`lineChart_${index}`" style="height:45vh;width:48vw;margin:25px auto">
    </div>
    <div v-if="isNoData" class="nodata">
      <img src="../../assets/icon_data_empty.png" alt="">
      <span>该条件下暂无数据</span>
    </div>
  </div>
</template>

<script>
import equipmentV2 from '../../store/modules/equipmentV2'
import parameterV2 from '../../store/modules/parameterV2'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'SensorChart',
  props: {
    sensorArry: { type: Array, required: true },
    equipmentId: { type: String, required: true },
    index: { type: Number, required: true },
    startTime: { type: String, required: true },
    endTime: { type: String, required: true }
  },
  data () {
    return {
      isNoData: false,
      lineChartDataArry: [],
      legendDataArry: [],
      myChart: ''
    }
  },
  mounted () {
  },
  computed: {
    ...mapState(equipmentV2, ['equipmentData', 'activeTitle', 'basic'])

  },
  methods: {
    ...mapMutations(equipmentV2, ['setActiveTitle']),
    ...mapActions(parameterV2, ['getParamerLine']),
    getData () {
      this.lineChartDataArry = []
      this.legendDataArry = []
      let paramsArry = []
      const indexArry = this.index === 1 ? [2, 3] : [0, 1]
      indexArry.forEach((i) => {
        if (this.sensorArry[i]) {
          paramsArry.push({
            id: this.equipmentId,
            iotName: this.sensorArry[i].iotName,
            name: this.sensorArry[i].name,
            dStart: `${this.startTime} 00:00:00`,
            dEnd: `${this.endTime} 23:59:59`
          })
          this.legendDataArry.push(this.sensorArry[i].name)
        }
      })

      if (paramsArry && paramsArry.length) {
        let reqIndex = 0
        paramsArry.forEach((params) => {
          this.getParamerLine(params).then(res => {
            if (res && res.length) {
              res.forEach((dataItem) => {
                const reqIndex = paramsArry.findIndex((c) => c.name === dataItem.sensorName)
                const dataObj = { time: `${dataItem.date} ${dataItem.moment}` }
                if (reqIndex === 1) {
                  dataObj.value2 = dataItem.value
                } else {
                  dataObj.value1 = dataItem.value
                }
                const lineData = this.lineChartDataArry.find((c) => c.time === dataObj.time)
                if (lineData) {
                  if (reqIndex === 1) {
                    lineData.value2 = dataObj.value2
                  } else {
                    lineData.value1 = dataObj.value1
                  }
                } else {
                  this.lineChartDataArry.push(dataObj)
                }
              })
            }
          }).finally(() => {
            if (reqIndex === paramsArry.length - 1) {
              this.$nextTick(() => {
                this.initLineChart()
              })
            }
            reqIndex++
          })
        })
      }
    },

    initLineChart () {
      // 基于准备好的dom，初始化echarts实例
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs[`lineChart_${this.index}`])
      }
      this.myChart.setOption({})
      const { lineChartDataArry, legendDataArry } = this
      lineChartDataArry.sort((a, b) => this.$Moment(a.time).unix() - this.$Moment(b.time).unix())
      const timeData = lineChartDataArry.map(item => item.time) || []
      const value1Data = lineChartDataArry.map(item => item.value1) || []
      const value2Data = lineChartDataArry.map(item => item.value2) || []
      this.isNoData = false
      if (timeData && !timeData.length) {
        this.isNoData = true
      }

      const chartOption = {
        color: ['#8E47E3', '#36E0FF'],
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: timeData,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#BBD4E9'
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: legendDataArry[0],
            position: 'left',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#BBD4E9'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              // y轴刻度线
              show: false
            },
            // 设置轴线的属性
            axisLine: {
              lineStyle: {
                color: '#07f',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          },
          legendDataArry.length === 2 && {
            type: 'value',
            name: legendDataArry[1],
            position: 'right',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#BBD4E9'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              // y轴刻度线
              show: false
            },
            // 设置轴线的属性
            axisLine: {
              lineStyle: {
                color: '#07f',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: legendDataArry[0],
            type: 'line',
            data: value1Data,
            yAxisIndex: 0,
            smooth: true,
            lineStyle: {
              color: 'rgb(142,71,227)'
            },
            showSymbol: false,
            // 拐点的样式的设置
            itemStyle: {
              opacity: 0
            },
            // 填充颜色设置
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgb(142,71,227)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgb(142,71,227,0)' // 100% 处的颜色
                  }
                ]
              }
            }

          },
          legendDataArry.length === 2 && {
            name: legendDataArry[1],
            type: 'line',
            data: value2Data,
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: 'rgb(54,224,255)'
            },
            showSymbol: false,
            // 拐点的样式的设置
            itemStyle: {
              opacity: 0
            },
            // 填充颜色设置
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgb(54,224,255)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgb(54,224,255,0)' // 100% 处的颜色
                  }
                ]
              }
            }
          }
        ]
      }

      this.myChart.setOption(chartOption)

      window.addEventListener('resize', () => {
        this.myChart.resize()
      })
    }
  }
}
</script>

<style lang="stylus">
.v3-sensorChart {
  .v2-radio-group {
    display: flex;
    justify-content: flex-end;
    margin-right: 60px;

    .selecter-one {
      position: absolute;
      top: 16%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999;
    }

    .selecter-tow {
      position: absolute;
      top: 16%;
      z-index: 999;
    }

    .el-radio-group {
      border: 1px solid rgba(0, 119, 255, 1);
      z-index: 999;
      border-radius: 4px;
    }

    .el-radio-button__inner {
      background: none;
      border: none;
      font-size: 16px;
      color: #999999;
    }

    .el-radio-button:nth-child(2), .el-radio-button:nth-child(3), .el-radio-button:nth-child(4), .el-radio-button:nth-child(5) .el-radio-button__inner {
      border-left: 1px solid rgba(0, 119, 255, 1);
    }

    .el-radio-button:first-child .el-radio-button__inner {
      border-left: none;
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      background: #0077ff;
      color: white;
    }

    .el-radio-button__inner:hover {
      color: #409EFF;
    }
  }

  position: relative;

  .nodata {
    img {
      position: absolute;
      top: 20%;
      left: 40%;
      width: 218px;
      height: 218px;
    }

    span {
      position: absolute;
      top: 70%;
      left: 42%;
      color: #6baae6;
      font-size: 20px;
    }
  }

  .el-input {
    width: 156px;
    margin-right: 10px;
  }

  .el-input__inner {
    text-align: center;
    border: 1px solid #07f;
    color: #fff;
    background: none;
  }

  .el-button--primary {
    margin-left: 30px;
    padding: 10px 0px !important;
    width: 120px;
    height: 36px;
    font-size: 16px;
    background: rgba(0, 119, 255, 1);
    border: 1px solid rgba(48, 145, 255, 1);
    border-radius: 4px;
  }

  .el-button--success {
    width: 120px;
    height: 36px;
    padding: 10px 0px !important;
    font-size: 16px;
    background: rgba(0, 181, 115, 1);
    border: 1px solid #23CC8F;
    border-radius: 4px;
  }
}
</style>
